import { render } from "./HomeKeyAquisitions.vue?vue&type=template&id=07f98361&scoped=true"
import script from "./HomeKeyAquisitions.vue?vue&type=script&lang=js"
export * from "./HomeKeyAquisitions.vue?vue&type=script&lang=js"

import "./HomeKeyAquisitions.vue?vue&type=style&index=0&id=07f98361&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f98361"]])

export default __exports__